export default __webpack_public_path__ + "static/media/logo.5a3e74d9.svg";